import logo from './logo.svg';
import "./assets/css/fonts/fontStyles.css";
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ProtectedRoute from './components/gcadmin/ProtectedRoute';
import GcLanding from './screens/gcstudent/Home/GcLanding';
import GcAbout from './screens/gcstudent/About/GcAbout';
import GcContact from './screens/gcstudent/Contact/GcContact';
import GcBlog from './screens/gcstudent/Blog/GcBlog';
import GcDigitalLibrary from './screens/gcstudent/digitallibrary/GcDigitalLibrary';
import GcLibrary from './screens/gcstudent/Library/GcLibrary';
import GcBookDetail from './screens/gcstudent/booksdetail/GcBookDetail';
import GcNotes from './screens/gcstudent/Notes/GcNotes';

import AdminMasterLayout from './layouts/gcadmin/adminMasterLayout/AdminMasterLayout';
import AdminDashboard from './screens/gcadmin/dashboard/AdminDashboard';
import GcAdminPage from './screens/gcadmin/dashboardpage/GcAdminPage';
import ManageBooks from './screens/gcadmin/managebooks/ManageBooks';
import DigitalBooksManage from './screens/gcadmin/digibooks/DigitalBooksManage';
import AdminIssued from './screens/gcadmin/adminissued/AdminIssued';
import ManageUsersPage from './screens/gcadmin/manageuserspage/ManageUsersPage';
import Reservations from './screens/gcadmin/reservations/Reservations';
import AdminManageNotes from './screens/gcadmin/adminmanagenotes/AdminManageNotes';
import GenerateReports from './screens/gcadmin/reports/GenerateReports';
import AdminDisputes from './screens/gcadmin/admindisputepages/AdminDisputes';
import AdminSettings from './screens/gcadmin/adminsettings/AdminSettings';

import StudentDashboard from './screens/gcstudent/dashboard/StudentDashboard';
import Disputes from './screens/gcstudent/disputes/Disputes';
import BrowseBooks from './screens/gcstudent/browsebooks/BrowseBooks';
import FlashCard from './screens/gcstudent/flashcard/FlashCard';
import MyBooks from './screens/gcstudent/mybook/MyBooks';
import SavedNotes from './screens/gcstudent/savednotes/SavedNotes';
import Profile from './screens/gcstudent/profile/Profile';
import SmartLibAI from './screens/gcstudent/smartlibAI/SmartLibAI';
import StudentLoginPage from './screens/gcstudent/stloginpage/StudentLoginPage';
import StudentForgotPasswordPage from './screens/gcstudent/studentforgetpassword/StudentForgotPasswordPage';
import StudentRegisterPage from './screens/gcstudent/stregister/StudentRegisterPage';

import StaffMyBooks from './screens/gcstaff/staffbooks/StaffMyBooks';
import StaffMyNotes from './screens/gcstaff/staffmynotes/StaffMyNotes';
import StaffFlashCardPage from './screens/gcstaff/staffflashcardpage/StaffFlashCardPage';
import StaffAIAssistant from './screens/gcstaff/satffaipage/StaffAIAssistant';
import TeacherLoginPage from './screens/gcstaff/staffloginpage/TeacherLoginPage';

import DisputesScreen from './screens/gcstaff/myDisputes/DisputesScreen';
import MyProfileScreen from './screens/gcstaff/myProfile/MyProfileScreen';

import StudentDashboardLayout from './layouts/gcstudent/studentdashboardLayout/StudentDashboardLayout';
import SavedPDFS from './screens/gcstudent/savedPdfs/SavedPDFS';

import SavedPDFs from './subsreens/gcstaff/myPDFs/SavedPDFs';

import StaffDashboard from './screens/gcstaff/dashboardstaff/StaffDashboard';
import Test from './screens/Test';
import AdminLoginPage from './screens/gcadmin/adminlogin/AdminLoginPage';
import { AppProvider } from './context/AppContext';

import ReservationsPage from './subsreens/gcadmin/reservationpage/ReservationsPage';
import BookDetailPage from './subsreens/gcstudent/bookdetailpage/BookDetailPage';
import ConfirmReservationPage from './subsreens/gcstudent/ConfirmReserve/ConfirmReservationPage';

import AdminReviews from './subsreens/gcadmin/reviews/AdminReviews';
import AdminNotification from './screens/gcadmin/adminnotifications/AdminNotification';
import TeacherNotifications from './screens/gcstaff/teachernotifications/TeacherNotifications';
import StudentNotifications from './screens/gcstudent/studentnotification/StudentNotifications';
import Review from './screens/gcadmin/reviews/Review';
import StudentReview from './screens/gcstudent/studentreview/StudentReview';
import TeacherReview from './screens/gcstaff/teacherreview/TeacherReview';
import SelectLoginPage from './subsreens/gcstudent/selectlogin/SelectLoginPage';
import ManageBlogsPage from './screens/gcadmin/adminBlogs/ManageBlogsPage';
import StudentResetPasswordPage from './screens/gcstudent/stresetpassword/StudentResetPasswordPage';
import TeacherForgotPasswordPage from './screens/gcstaff/staffforgotpassword/TeacherForgotPasswordPage';
import TeacherResetPasswordPage from './screens/gcstaff/teacherresetpassword/TeacherResetPasswordPage';
import AdminForgotPasswordPage from './screens/gcadmin/adminforgotpassword/AdminForgotPasswordPage';
import AdminResetPasswordPage from './screens/gcadmin/adminresetpassword/AdminResetPasswordPage';

import FAQManagement from './screens/gcadmin/faqmanagement/FAQManagement';

import NotFoundPage from './subsreens/gcadmin/NotFoundPage';


function App() {
  return (
    // <AppProvider>
    <Routes>
      {/* ---------- PUBLIC ROUTES ---------- */}
      <Route path='/' element={<GcLanding />} />
      <Route path='/about' element={<GcAbout />} />
      <Route path='/contact' element={<GcContact />} />
      <Route path='/blogs' element={<GcBlog />} />
      <Route path='/digital-library' element={<GcDigitalLibrary />} />
      <Route path='/library' element={<GcLibrary />} />
      <Route path='' element={<GcBookDetail />} />
      <Route path='/confirm-reservation' element={<ConfirmReservationPage />} />
      <Route path='select-login' element={<SelectLoginPage />} />
      <Route path='notes' element={<GcNotes />} />
      <Route path='/test' element={<Test />} />

      <Route path='/admin/login' element={<AdminLoginPage />} />
      <Route path='/admin/forgot-password' element={<AdminForgotPasswordPage />} />
      <Route path='/admin/reset-password' element={<AdminResetPasswordPage />} />
      <Route path='/student/login' element={<StudentLoginPage />} />
      <Route path='student/forgot-password' element={<StudentForgotPasswordPage />} />
      <Route path='/student/reset-password' element={<StudentResetPasswordPage/>}/>
      <Route path='/student/register' element={<StudentRegisterPage />} />
      <Route path='/teacher/login' element={<TeacherLoginPage />} />
      <Route path='/teacher/forgot-password' element={<TeacherForgotPasswordPage />} />
      <Route path='/teacher/reset-password' element={<TeacherResetPasswordPage />} />

      {/* ---------- ADMIN PROTECTED ROUTES ---------- */}
      <Route element={<ProtectedRoute allowedRole="admin" />}>
        <Route path='/admin/dashboard' element={<AdminDashboard />} />
        <Route path='/dashboard' element={<GcAdminPage />} />
        <Route path='/admin/manage-books' element={<ManageBooks />} />
        <Route path='/admin/digital-lib' element={<DigitalBooksManage />} />
        <Route path='/admin/issued-books' element={<AdminIssued />} />
        <Route path='/admin/manage-users' element={<ManageUsersPage />} />
        <Route path='/admin/reservations' element={<Reservations />} />
        <Route path='/admin/manage-notes' element={<AdminManageNotes />} />
        <Route path='/admin/reports' element={<GenerateReports />} />
        <Route path='/admin/disputes' element={<AdminDisputes />} />
        <Route path='/admin/reviews' element={<Review />} />
        <Route path='/admin/blogs' element={<ManageBlogsPage />} />
        <Route path='/admin/settings' element={<AdminSettings />} />
        <Route path='/admin/notifications' element={<AdminNotification />} />
        <Route path='/admin/FAQManagement' element={<FAQManagement />} />
      </Route>

      {/* ---------- TEACHER PROTECTED ROUTES ---------- */}
      <Route element={<ProtectedRoute allowedRole="teacher" />}>
        <Route path='/teacher/dashboard' element={<StaffDashboard />} />
        <Route path='/teacher/my-books' element={<StaffMyBooks />} />
        <Route path='/teacher/my-notes' element={<StaffMyNotes />} />
        <Route path='/teacher/flash-cards' element={<StaffFlashCardPage />} />
        <Route path='/teacher/libraro' element={<StaffAIAssistant />} />
        <Route path='/teacher/reviews' element={<TeacherReview />} />
        <Route path='/teacher/disputes' element={<DisputesScreen />} />
        <Route path='/teacher/profile' element={<MyProfileScreen />} />
        <Route path='/teacher/saved-pdfs' element={<SavedPDFs />} />
        <Route path='/teacher/notifications' element={<TeacherNotifications />} />
      </Route>

      {/* ---------- STUDENT PROTECTED ROUTES ---------- */}
      <Route element={<ProtectedRoute allowedRole="student" />}>
        <Route path='/student/dashboard' element={<StudentDashboard />} />
        <Route path='/student/dashbord' element={<StudentDashboardLayout />} />
        <Route path='/student/disputes' element={<Disputes />} />
        <Route path='/student/flash-cards' element={<FlashCard />} />
        <Route path='/student/my-books' element={<MyBooks />} />
        <Route path='/student/saved-notes' element={<SavedNotes />} />
        <Route path='/student/profile' element={<Profile />} />
        <Route path='/student/libraro' element={<SmartLibAI />} />
        <Route path='/student/saved-pdfs' element={<SavedPDFS />} />
        <Route path='/student/reserve-book' element={<ReservationsPage />} />
        <Route path='/student/review' element={<StudentReview />} />
        <Route path='/student/notifications' element={<StudentNotifications />} />
      </Route>

      <Route path='/*' element={<NotFoundPage/>} />
    </Routes>
    // </AppProvider>
  );
}

export default App;